import API from '../../../services/API';
import { setError, startSpinner, stopSpinner } from '../../common/actionCreators';
import { configs } from '../../../constants/configs/configs';
import { urlChunks } from '../../../constants/configs/endpoints';
import { NOTIFICATION_ACTION_TYPES } from '../../../constants/actionTypes/secureInboxActionTypes';
import { environmentActionTypes } from '../../../constants/actionTypes/commonActionTypes';

const {
    endpoints: {
        GET_UNREAD_NOTIFICATION_COUNT,
        NOTIFICATIONS
    }
} = configs;

const {
    INBOX_SEARCH
} = urlChunks;


export const setNotifications = notifications => ({
    type: NOTIFICATION_ACTION_TYPES.SET_NOTIFICATIONS,
    notifications
});

export const setFilteredNotifications = notifications => ({
    type: NOTIFICATION_ACTION_TYPES.SET_FILTERED_NOTIFICATIONS,
    notifications
});

export const clearNotifications = () => ({
    type: NOTIFICATION_ACTION_TYPES.CLEAR_NOTIFICATIONS_STATE
});

export const setUnreadNotifications = numberUnread => ({
    type: NOTIFICATION_ACTION_TYPES.SET_UNREAD_NOTIFICATIONS,
    numberUnread
});

export const updateNotificationsPagination = payload => ({
    type: NOTIFICATION_ACTION_TYPES.UPDATE_NOTIFICATIONS_PAGINATION,
    payload
});

export const updateIconUnreadCount = numberUnread => ({
    type: environmentActionTypes.UPDATE_ICON_UNREAD_COUNT,
    numberUnread
});

/************************

 # Async action creators

 ************************/


const actions = { setError, startSpinner, stopSpinner };

export const fetchNotifications = (part, id, pageNumber, subject = '') => async (dispatch, getState) => {

    let url, action;
    const isEncrypted = isNaN(id);
    switch (subject) {
        case '':

            url = NOTIFICATIONS.processReplacements({ part, id, isEncrypted, pageNumber });
            action = setNotifications;

            break;
        default:

            url = (NOTIFICATIONS + INBOX_SEARCH).processReplacements({ part, id, isEncrypted, pageNumber, subject });
            action = setFilteredNotifications;

            break;
    }

    const data = await API.getData(url, dispatch, actions, true, getState());

    if (data && data.success) {
        dispatch(action(data.payload));
        return Promise.resolve(data.payload);
    }
};

export const fetchUnreadNotificationCount = (part, id) => async (dispatch, getState) => {
    const isEncrypted = isNaN(id);
    const endpoint = GET_UNREAD_NOTIFICATION_COUNT.processReplacements({ part, id, isEncrypted });
    const data = await API.getData(endpoint, dispatch, actions, false, getState());
    if (data && data.success) {
        dispatch(updateIconUnreadCount(data.payload));
        return Promise.resolve(data.payload);
    }
};

export const fetchConsumerInboxUnreadNotificationCount = (part, id) => async (dispatch, getState) => {
    const isEncrypted = isNaN(id);
    const endpoint = GET_UNREAD_NOTIFICATION_COUNT.processReplacements({ part, id, isEncrypted });
    const data = await API.getData(endpoint, dispatch, actions, false, getState());
    sessionStorage.setItem('consumerInboxUnReadNotificationCount', data ? data.payload : '');
    if (data && data.success) {
        dispatch(setUnreadNotifications(data.payload));
        return Promise.resolve(data.payload);
    }
};


/************************

 # Grouped Action Creators

 ************************/


export const notificationsActionCreators = {
    fetchNotifications,
    clearNotifications,
    fetchUnreadNotificationCount,
    updateNotificationsPagination,
    fetchConsumerInboxUnreadNotificationCount
};